"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedSlotModel = void 0;
class ExtendedSlotModel {
    constructor(calendarModel, slotData) {
        this.id = slotData.id || '';
        this.startTime = slotData.startTime || 0;
        this.duration = slotData.duration || 0;
        this.isActive = !slotData.disabled || false;
        this.timeZone = calendarModel.timeZone || '';
    }
}
exports.ExtendedSlotModel = ExtendedSlotModel;
/**
 * Provide calendar metadata and calendar model data.
 */
class CalendarDataProvider {
    constructor(calendarModelsJson) {
        this.slotDictionary = this.getCommonSlotModelDictionary(calendarModelsJson);
        this.calendarModels = calendarModelsJson;
        this.currentCalendarKey = '';
    }
    getCurrentCalendarKey() {
        return this.currentCalendarKey;
    }
    changeCalendarKey(calendarKey) {
        this.currentCalendarKey = calendarKey;
    }
    getCurrentCalendarModel() {
        return JSON.parse(JSON.stringify(this.calendarModels[this.getCurrentCalendarKey()]));
    }
    getCurrentCalendarConfiguration() {
        return JSON.parse(JSON.stringify(this.calendarModels[this.getCurrentCalendarKey()].configuration));
    }
    getDateIdBySlotId(slotId) {
        var indexedSlotData = (this.slotDictionary[this.getCurrentCalendarKey()] || {})[slotId];
        if (typeof indexedSlotData !== 'undefined' && indexedSlotData.dateId) {
            return indexedSlotData.dateId;
        }
        return '';
    }
    getSlotData(slotId) {
        var indexedSlotData = (this.slotDictionary[this.getCurrentCalendarKey()] || {})[slotId];
        var calendarModel = this.getCurrentCalendarModel();
        if (typeof indexedSlotData === undefined) {
            return new ExtendedSlotModel(calendarModel, {
                id: '',
                startTime: 0,
                duration: 0,
                disabled: false
            });
        }
        return new ExtendedSlotModel(calendarModel, indexedSlotData.slotModel);
    }
    getCommonSlotModelDictionary(calendarModels) {
        const slotDictionary = new Map();
        if (typeof calendarModels !== 'undefined') {
            // indexing slot of all calendars to query them based on slotId and calendarId
            for (let calendarKey in calendarModels) {
                let calendarModel = calendarModels[calendarKey];
                slotDictionary[calendarKey] = new Map();
                for (let calendarDay of calendarModel.days) {
                    for (let slotModel of calendarDay.slots) {
                        let slotId = slotModel.id;
                        // storing dateId along with slotModel to get dateId by slotId
                        slotDictionary[calendarKey][slotId] = {
                            slotModel: slotModel,
                            dateId: calendarDay.id
                        };
                    }
                }
            }
        }
        return slotDictionary;
    }
}
exports.default = CalendarDataProvider;
